(function () {
    'use strict';

    angular
        .module('jcsfApp')
        .factory('RSAsService', RSAsService);

    RSAsService.$inject = ['$http', '$filter', 'modelTransformer', 'messaging', 'events', 'RSA'];

    function RSAsService($http, $filter, modelTransformer, messaging, events, RSA) {
        var baseUrl = '/api/RSA/';
        var RSAs = [];
        var dId = 0;
        var rsa = {};
        var service = {
            init: init
        };
        messaging.subscribe(events.message._GET_RSA_LIST_, getRSAs);
        messaging.subscribe(events.message._DELETE_RSA_, deleteRSA);
        messaging.subscribe(events.message._GET_RSA_, getRSA);
        messaging.subscribe(events.message._SAVE_RSA_, saveRSA);

        return service;
        function init() {
            RSAs = [];
            rsa = {};
        }

        function getRSAs(clear) {
            if (clear === true) {
                RSAs = [];
            }

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetList/';

            $http.get(baseUrl + url)
                .then(getRSAsSuccessHandler, getRSAsErrorHandler);

        }
        function getRSA(id) {

            dId = id;
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.get(baseUrl + 'Get/' + dId)
                .then(getRSASuccessHandler, getRSAErrorHandler);

        }
        function deleteRSA(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'deleteRSA/' + id)
                .then(deleteRSASuccessHandler, deleteRSAErrorHandler);
        }
        function saveRSA(src) {

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'saveRSA/', src)
                .then(saveRSASuccessHandler, saveRSAErrorHandler);
        }
        function getRSAsSuccessHandler(results) {
           
            if (results.data && results.data.length) {
                var result = [];
                angular.forEach(results.data, function (d) { 
                    var dr =   modelTransformer.transform(d, RSA);
                    result.push(dr);
                });
                RSAs = result;
                messaging.publish(events.message._GET_RSA_LIST_COMPLETE_, [RSAs]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getRSAsErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getRSASuccessHandler(results) {
            if (results.data) { 
                rsa = modelTransformer.transform(results.data, RSA) ;
                messaging.publish(events.message._GET_RSA_COMPLETE_, [rsa]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                getRSAErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function deleteRSASuccessHandler(results) {
            if (results) {
                var id = angular.toJson(results.data.RSAId);
                var ix = -1;
                var match = $filter('filter')(RSAs, function (p) {
                    return Number(p.RSAId) === Number(id);
                })[0];
                if (match) {
                    ix = RSAs.indexOf(match);
                }
                if (ix >= 0) {
                    RSAs.splice(ix, 1);
                    messaging.publish(events.message._RSA_LIST_UPDATED_, [RSAs]);
                }
                messaging.publish(events.message._DELETE_RSA_COMPLETE_, [id]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                deleteRSAErrorHandler({ data: { error_description: 'No Records Deleted' } });
            }
        }
        function saveRSASuccessHandler(results) {
            if (results.data) {
                var result = results.data;
                rsa = updateOrAddRSA(result); 
                messaging.publish(events.message._SAVE_RSA_COMPLETE_, [rsa]);
                messaging.publish(events.message._RSA_LIST_UPDATED_, [RSAs]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
                messaging.publish(events.message._SAVE_SUCCESS_);
            } else {
                saveRSAErrorHandler({ data: { error_description: 'No Records Saved' } });
            }
        }
        function updateOrAddRSA(result) {
            rsa = modelTransformer.transform(result, RSA);

            return rsa;
        }

        function getRSAErrorHandler(results) {
            messaging.publish(events.message._GET_RSA_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get RSA from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function getRSAsErrorHandler(results) {
            messaging.publish(events.message._GET_RSA_LIST_FAILED);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get RSA List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function deleteRSAErrorHandler(results) {
            messaging.publish(events.message._DELETE_RSA_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to Delete RSA from the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function saveRSAErrorHandler(results) {
            messaging.publish(events.message._SAVE_RSA_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to save RSA to the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
    }
})();